import React from 'react';
const StickyBottomBanner = () => {
  return <div className="fixed bottom-0 left-0 right-0 bg-[#042A1D] text-white p-3 shadow-md z-50" data-id="element-224">
      {/* Desktop version - horizontal layout */}
      <div className="max-w-6xl mx-auto items-center justify-center hidden md:flex" data-id="element-225">
        <a href="https://www.thaura.co/products/drift" className="w-1/2 mx-auto cta-button" target="_blank" rel="noopener" data-id="element-226">
          <button className="bg-[#84f75d] hover:bg-[#6dd84a] text-black font-bold py-2 px-6 rounded-md transition duration-300 text-lg w-full" data-id="element-227">
            GET UP TO 50% OFF →
          </button>
        </a>
      </div>
      {/* Mobile version - stacked layout */}
      <div className="flex flex-col items-center justify-center md:hidden py-3" data-id="element-228">
        <a href="https://www.thaura.co/products/drift" className="w-full cta-button" target="_blank" rel="noopener" data-id="element-229">
          <button className="bg-[#84f75d] hover:bg-[#6dd84a] text-black font-bold py-3.5 px-6 rounded-md transition duration-300 text-lg w-full text-center" data-id="element-230">
            GET UP TO 50% OFF →
          </button>
        </a>
      </div>
    </div>;
};
export default StickyBottomBanner;